import styled from 'styled-components';

export const CardContainer = styled.div`
  padding: 0 5px 4px;

  &:first-child {
    padding-top: 4px;
  }
`;
